"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSEPSelectPaymentComponent = void 0;
const core_1 = require("@angular/core");
const expresspay_services_1 = require("../../../shared/services/expresspay.services");
const helper_service_1 = require("../../../../mma/shared/services/helper.service");
const index_1 = require("../../../../mma/shared/index");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const _ = require("underscore");
class CSEPSelectPaymentComponent {
    constructor(genericContentServiceV2, expressPayService, helperService, modalService) {
        this.genericContentServiceV2 = genericContentServiceV2;
        this.expressPayService = expressPayService;
        this.helperService = helperService;
        this.modalService = modalService;
        this.classes = 'col-12';
        this.showRemainingFunds = false;
        this.calendarBillingAccount = false;
        this.next = new core_1.EventEmitter();
        this.amtToPay = new core_1.EventEmitter();
        this.accNo = new core_1.EventEmitter();
        this.prepaidBillingDetailsEmitter = new core_1.EventEmitter();
        this.scrollTop();
    }
    ngOnInit() {
        this.loader = true;
        this.showForm = true;
        this.isAuthenticated();
        this.changePinSuccessMessage = false;
        this.getBillingAddress();
        this.getPrepaidBillingDetails();
        this.getRenewalDateEligibility();
        this.getGenericContent();
    }
    getBillingAddress() {
        this.loader = true;
        this.expressPayService.getPersonalInformation().subscribe((res) => {
            this.personalInfo = res;
            this.getStartedUrl = '/online-warranty/?mobileNumber=' + this.personalInfo.mobileNumber;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getPrepaidBillingDetails() {
        this.loader = true;
        this.expressPayService.getPrepaidBillingDetails()
            .subscribe((prepaidBillingSummary) => {
            this.prepaidBillingDetails = prepaidBillingSummary;
            this.restoreAmount = prepaidBillingSummary.amountToUnsuspend;
            this.setDefaultAmount();
            this.prepaidBillingDetailsEmitter.emit(this.prepaidBillingDetails);
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    setDefaultAmount() {
        if (this.restoreAmount) {
            this.diffAmt = this.restoreAmount;
            this.convert(this.diffAmt);
        }
        else if (this.prepaidBillingDetails) {
            if (this.prepaidBillingDetails.fundsAvailable > this.prepaidBillingDetails.currentPlanCost) {
                this.diffAmt = 5;
                this.convert(this.diffAmt);
                // Display remainiing funds
                this.showRemainingFunds = true;
            }
            else {
                this.diffAmt = parseFloat(this.prepaidBillingDetails.currentPlanCost) - parseFloat(this.prepaidBillingDetails.fundsAvailable);
                if (this.diffAmt < 5) {
                    this.diffAmt = 5;
                }
                this.convert(this.diffAmt);
            }
        }
    }
    nextSection(type, remainingFunds, differentAmt, planCost) {
        if (this.restoreAmount) {
            if (differentAmt >= this.restoreAmount) {
                this.next.emit(true);
            }
            else {
                this.openTT();
            }
        }
        else {
            if (differentAmt < 5) {
                this.openTT();
            }
            else if (differentAmt >= 5 && differentAmt < (planCost - remainingFunds)) {
                this.openTT();
            }
            else if (differentAmt >= 5 && (differentAmt + remainingFunds) > 500) {
                this.openTT();
            }
            else if (remainingFunds >= 500) {
                this.openTT();
            }
            else {
                this.next.emit(true);
            }
        }
        const paymentDetails = {
            'amountToPay': this.addFundAmt,
            'payInFull': false,
            'payPastDueBalance': false,
            'e911FeeAmount': this.prepaidBillingDetails.adminFeeAmount,
            'totalDueToday': this.addFundAmt + this.prepaidBillingDetails.adminFeeAmount
        };
        this.amtToPay.emit(paymentDetails);
        // this.next.emit(true);
    }
    openMyModal(event) {
        // this.modalService.open(content, { windowClass: 'dark-modal' });
        const target = event.target;
        if (!_.isEmpty(target) && target.checked) {
            this.modelRef = this.modalService.open(this.pastDuePopup, { windowClass: 'dark-modal' });
        }
    }
    close() {
        this.modelRef.close();
    }
    scrollTop() {
        window.scrollTo(0, 200);
    }
    scrollBottom() {
        window.scrollTo(0, 630);
    }
    openTT() {
        this.tooltip.open();
    }
    closeTT() {
        this.tooltip.close();
    }
    openTooltip() {
        this.e911Tooltip.open();
    }
    closeTooltip() {
        this.e911Tooltip.close();
    }
    inputOnlyNumberAndPeriod(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46);
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    open(content) {
        this.modalService.open(content, { size: 'lg', windowClass: 'dark-modal' });
    }
    convert(event) {
        let fraction;
        if (event !== null) {
            event = event.toString();
            if (event.includes('.')) {
                const beforeDecimal = event.split('.')[0];
                fraction = event.split('.')[1];
                if (event.split('.')[1].length > 2) {
                    fraction = event.split('.')[1].substring(0, 2);
                    this.addFundAmt = beforeDecimal + '.' + fraction;
                    this.addFundAmt = parseFloat(this.addFundAmt);
                }
                else {
                    this.addFundAmt = beforeDecimal + '.' + fraction;
                    this.addFundAmt = parseFloat(this.addFundAmt);
                }
            }
            else {
                this.addFundAmt = parseFloat(event);
            }
        }
    }
    changeSection() {
        this.next.emit(true);
    }
    goToMyExpressPay() {
        this.helperService.onNavigate('/my_account/personal/express-pay/');
    }
    isAuthenticated() {
        this.loader = true;
        this.expressPayService.loginAuthentication().subscribe((data) => {
            if (_.isEmpty(data)) {
                this.hideSection = true;
                this.goToMyExpressPay();
            }
        }, (err) => {
            this.loader = false;
        });
    }
    // Prepaid-SDR - get Renewal Date Eligibility
    getRenewalDateEligibility() {
        this.expressPayService.getRenewalDateEligibility(true).subscribe((data) => {
            this.calendarBillingAccount = data === null || data === void 0 ? void 0 : data.calendarBilling;
        }, (err) => {
            this.calendarBillingAccount = false;
        });
    }
    getGenericContent() {
        const genericContentIds = [
            'genericInstructionalE911FeeNote',
            '/generic/instructional/payExtraCharges',
            'genericContentConvenienceFee'
        ];
        this.genericContentServiceV2.getBulkGenericContent(genericContentIds).subscribe((bulkGenericContent) => {
            for (const genericContentItem of bulkGenericContent) {
                switch (genericContentItem.id) {
                    case '/generic/instructional/payExtraCharges':
                        this.extraChargeText = genericContentItem;
                        break;
                    case 'genericInstructionalE911FeeNote':
                        this.e911Message = genericContentItem;
                        break;
                    case 'genericContentConvenienceFee':
                        this.convenienceMessage = genericContentItem;
                        break;
                    default:
                        break;
                }
            }
        }, () => {
            this.e911Message = '';
            this.extraChargeText = '';
            this.convenienceMessage = '';
        });
    }
}
exports.CSEPSelectPaymentComponent = CSEPSelectPaymentComponent;
//# sourceMappingURL=selectpayment.component.js.map